import { act } from 'react-dom/test-utils'
import {
    SET_USER_LOGGED_IN,
    SET_USER_AUTH_DATA,
    RESET_STATE,
    SET_KYC_AND_SETTLEMENT,
} from './auth.type'

const AUTH_INIT_STATE = {
    user_loggedIn: false,
    user_authData: null,
    kyc_settlement: []
}

const AuthReducer = (state = AUTH_INIT_STATE, action) => {
    switch (action.type) {
      case SET_USER_LOGGED_IN:
        return {
          ...state,
          user_loggedIn: action.payload,
        };
      case SET_USER_AUTH_DATA:
        return {
          ...state,
          user_authData: {
            ...(state.user_authData || {}), // keep existing fields
            ...action.payload, // overwrite only what comes from backend
          },
        };
      case SET_KYC_AND_SETTLEMENT:
        return {
          ...state,
          kyc_settlement: action.payload,
        };
      case RESET_STATE:
        return AUTH_INIT_STATE;
      default:
        return state;
    }
}

export default AuthReducer;